import React, { useState } from 'react';
import Header from '../components/Header';
import NavigationMenu from '../components/NavigationMenu';
import Card from '../components/Card';
import Input from '../components/Input';
import Button from '../components/Button';
const WithdrawalForms = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    nic: '',
    aliado: '',
    territorio: '',
    gestor: '',
    asesor: '',
    observaciones: ''
  });
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    alert('Formulario enviado correctamente');
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-458">
      <Header username="Carlos Pérez" onMenuClick={handleMenuToggle} notificationCount={3} data-id="element-459" />
      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-460" />
      <main className="p-4 pb-20" data-id="element-461">
        <h1 className="text-xl font-semibold mb-4" data-id="element-462">
          Formulario de Desistimiento
        </h1>
        <Card data-id="element-463">
          <form onSubmit={handleSubmit} data-id="element-464">
            <div className="mb-4" data-id="element-465">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-466">
                Fecha de solicitud
              </label>
              <input type="text" value={new Date().toLocaleDateString()} disabled className="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg text-gray-700" data-id="element-467" />
            </div>
            <Input label="NIC o cuenta" placeholder="Ingrese el NIC o número de cuenta" name="nic" value={formData.nic} onChange={handleChange} required data-id="element-468" />
            <div className="mb-4" data-id="element-469">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-470">
                Aliado
              </label>
              <select name="aliado" value={formData.aliado} onChange={e => setFormData(prev => ({
              ...prev,
              aliado: e.target.value
            }))} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-471">
                <option value="" data-id="element-472">Seleccione un aliado</option>
                <option value="aliado1" data-id="element-473">Aliado 1</option>
                <option value="aliado2" data-id="element-474">Aliado 2</option>
                <option value="aliado3" data-id="element-475">Aliado 3</option>
              </select>
            </div>
            <div className="mb-4" data-id="element-476">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-477">
                Territorio
              </label>
              <select name="territorio" value={formData.territorio} onChange={e => setFormData(prev => ({
              ...prev,
              territorio: e.target.value
            }))} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-478">
                <option value="" data-id="element-479">Seleccione un territorio</option>
                <option value="territorio1" data-id="element-480">Territorio 1</option>
                <option value="territorio2" data-id="element-481">Territorio 2</option>
                <option value="territorio3" data-id="element-482">Territorio 3</option>
              </select>
            </div>
            <div className="mb-4" data-id="element-483">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-484">
                Gestor
              </label>
              <select name="gestor" value={formData.gestor} onChange={e => setFormData(prev => ({
              ...prev,
              gestor: e.target.value
            }))} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-485">
                <option value="" data-id="element-486">Seleccione un gestor</option>
                <option value="gestor1" data-id="element-487">Gestor 1</option>
                <option value="gestor2" data-id="element-488">Gestor 2</option>
                <option value="gestor3" data-id="element-489">Gestor 3</option>
              </select>
            </div>
            <div className="mb-4" data-id="element-490">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-491">
                Asesor call center
              </label>
              <select name="asesor" value={formData.asesor} onChange={e => setFormData(prev => ({
              ...prev,
              asesor: e.target.value
            }))} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-492">
                <option value="" data-id="element-493">Seleccione un asesor</option>
                <option value="asesor1" data-id="element-494">Asesor 1</option>
                <option value="asesor2" data-id="element-495">Asesor 2</option>
                <option value="asesor3" data-id="element-496">Asesor 3</option>
              </select>
            </div>
            <div className="mb-4" data-id="element-497">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-498">
                Observaciones
              </label>
              <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500" placeholder="Ingrese sus observaciones" data-id="element-499"></textarea>
            </div>
            <Button type="submit" fullWidth data-id="element-500">
              Enviar solicitud
            </Button>
          </form>
        </Card>
      </main>
    </div>;
};
export default WithdrawalForms;